export default "__VITE_ASSET__DYAa16rY__"